// extracted by mini-css-extract-plugin
export default {"modal":"modal_modal__3dCNk","wrapper":"modal_wrapper__nAVOE","disabled":"modal_disabled__hBj-3"};